import {
  DEFAULT_THEME,
  THEME_MODES,
  THEME_MODE_LIGHT,
  THEME_MODE_DARK,
  THEME_MODE_CTRST_LIGHT,
  THEME_MODE_CTRST_DARK,
  DEAULT_THEME_MODE
} from './constants';

const defaultTheme = { mode: DEAULT_THEME_MODE };

export const getTheme = (props) => {
  return props.theme && props.theme[DEFAULT_THEME]
    ? props.theme[DEFAULT_THEME]
    : defaultTheme;
}

export const isDefaultThemeMode = (props) => {
  const { mode } = getTheme(props);
  return mode === DEAULT_THEME_MODE;
}

const getThemeModeLabel = (id) => {
  switch (id) {
    case THEME_MODE_LIGHT:
      return 'Standarts';
    case THEME_MODE_DARK:
      return 'Balts uz melna';
    case THEME_MODE_CTRST_LIGHT:
      return 'Melns uz dzeltena';
    case THEME_MODE_CTRST_DARK:
      return 'Dzeltens uz melna';
    default:
      return `- ${id} -`;
  }
}

export const getThemeModes = () => {
  const modes = {};
  THEME_MODES.forEach(id => {
    modes[id] = getThemeModeLabel(id);
  });
  return modes;
};

const themedVariants = (variantProp, variants) => {
  return (props) => {
    const theme = getTheme(props);
    const modes = variants[props[variantProp]];
    if (!modes) return undefined;
    return modes[theme.mode];
  };
}

const themed = (modes) => {
  if (typeof modes === 'string') {
    return themedVariants(...arguments);
  }
  return props => {
    const theme = getTheme(props);
    return modes[theme.mode];
  };
}

export default themed;



// WEBPACK FOOTER //
// ./src/core/theme/themed.js